import { deleteApi, getApi, postApi, putApi } from "../controllers/_apiHelper";
import { apiEndpoints } from "./api/endpoints";

const checkLogIn = (name, password, setResponse) => {
  postApi(
    apiEndpoints.loginApi,
    {
      username: name,
      password,
    },
    setResponse
  );
};

const getAllTeams = (userId, setResponse) => {
  postApi(apiEndpoints.getTeamApi, { userId }, setResponse);
};

const saveSelectedTeams = (userId, rapidEventIdList, setResponse) => {
  postApi(
    apiEndpoints.postSelectedTeamApi,
    {
      rapidEventId: rapidEventIdList,
      userId,
    },
    setResponse
  );
};

const updateResfreshOdds = (userId, setResponse) => {
  postApi(apiEndpoints.updateOddsApi, { userId }, setResponse);
};

const updateSelectedOdds = (userId, rapidEventIdList, setResponse) => {
  putApi(
    apiEndpoints.copyTeamApi,
    {
      rapidEventId: rapidEventIdList,
      userId,
    },
    setResponse
  );
};

const getBettingEvents = (date, userId, setResponse) => {
  postApi(
    apiEndpoints.bettingEventApi,
    {
      userId,
      selectedDate: date,
    },
    setResponse
  );
};

const saveBettingEvents = (selectedDate, userId, customerId, bettingInfo, setResponse) => {
  postApi(
    apiEndpoints.saveBettingEventApi,
    {
      userId,
      customerId,
      selectedDate,
      bettingDetails: bettingInfo,
    },
    setResponse
  );
};

const saveBettingEventsConfirm = (selectedDate, userId, customerId, bettingInfo, setResponse) => {
  postApi(
    apiEndpoints.confirmSaveBettingEventApi,
    {
      userId,
      customerId,
      selectedDate,
      betConfirmDetails: bettingInfo,
    },
    setResponse
  );
};

const getCustomer = (userId, setResponse) => {
  postApi(apiEndpoints.getCustomerApi, { userId }, setResponse);
};

const updateCustomer = (customerInfo, setResponse) => {
  postApi(
    apiEndpoints.updateCustomerApi,
    {
      customerId: customerInfo.customerId,
      customerName: customerInfo.customerName,
      commission: Number(customerInfo.commission),
      active: customerInfo.active,
      betLimit: Number(customerInfo.betLimit),
    },
    setResponse
  );
};

const saveCustomer = (userId, customerInfo, setResponse) => {
  postApi(
    apiEndpoints.saveCustomerApi,
    {
      customerName: customerInfo.customerName,
      commission: Number(customerInfo.commission),
      userId,
      betLimit: Number(customerInfo.betLimit),
    },
    setResponse
  );
};

const getOutstanding = (userId, setResponse) => {
  postApi(apiEndpoints.getMemberOutstandingApi, { userId }, setResponse);
};

const updateOutstanding = (bettingId, amount, odds, userId, setResponse) => {
  postApi(
    apiEndpoints.updateMemberVoucherApi,
    {
      bettingId,
      amount: parseInt(amount, 10),
      userId: parseInt(userId, 10),
      odds,
    },
    setResponse
  );
};

const removeOutstanding = (bettingId, setResponse) => {
  postApi(apiEndpoints.removeMemberVoucherApi, { bettingId }, setResponse);
};

const getwinloseReport = (userId, startDate, endDate, setResponse) => {
  postApi(
    apiEndpoints.getWinLoseReportApi,
    {
      userId,
      startDate,
      endDate,
    },
    setResponse
  );
};

const getEventResult = (userId, startDate, setResponse) => {
  postApi(
    apiEndpoints.getEventResultApi,
    {
      userId,
      selectedDate: startDate,
    },
    setResponse
  );
};

const calculateEventResult = (userId, startDate, setResponse) => {
  postApi(
    apiEndpoints.calculateVoucherApi,
    {
      userId,
      selectedDate: startDate,
    },
    setResponse
  );
};

const getSingleLiveData = (startDate, isBody, userId, setResponse) => {
  postApi(
    apiEndpoints.getSingleLiveDataApi,
    {
      searchDate: startDate,
      userId,
      isBody,
    },
    setResponse
  );
};

const getVoucherDetails = (rapidEventId, userId, setResponse) => {
  postApi(
    apiEndpoints.getVoucherDetailApi,
    {
      rapidEventId,
      userId: parseInt(userId, 10),
    },
    setResponse
  );
};

const getOverallVoucher = (customerId, setResponse) => {
  getApi(`${apiEndpoints.getOverallVoucherApi}/${parseInt(customerId, 10)}`, setResponse);
};

const updateOverallVoucher = (voucherList, setResponse) => {
  postApi(apiEndpoints.updateVoucherApi, { voucherList }, setResponse);
};

const getPurchasedVouchers = (date, userId, setResponse) => {
  getApi(`${apiEndpoints.bettingPurchaseApi}/${date}/${userId}`, setResponse);
};

const createPurchasedVoucher = (data, setResponse) => {
  postApi(apiEndpoints.bettingPurchaseApi, { ...data }, setResponse);
};

const updatePurchasedVoucher = (data, setResponse) => {
  putApi(apiEndpoints.bettingPurchaseApi, { ...data }, setResponse);
};

const deletePurchasedVoucher = (id, setResponse) => {
  deleteApi(`${apiEndpoints.bettingPurchaseApi}/${id}`, setResponse);
};

const getEventListForSelect = (id, setResponse) => {
  getApi(`${apiEndpoints.bettingPurchaseApi}/event-list/${id}`, setResponse);
};

const calculatePurchasedVouchers = (id, date, setResponse) => {
  postApi(
    `${apiEndpoints.bettingPurchaseApi}/calculate`,
    {
      userId: id,
      selectedDate: date,
    },
    setResponse
  );
};

const updateSetting = (data, setResponse) => {
  putApi(apiEndpoints.settingApi, { ...data }, setResponse);
};

const fetchSetting = (id, setResponse) => {
  getApi(`${apiEndpoints.settingApi}/${id}`, setResponse);
};

export const oddsService = {
  getAllTeams,
  saveSelectedTeams,
  updateResfreshOdds,
  updateSelectedOdds,
  checkLogIn,
  getBettingEvents,
  saveBettingEvents,
  getCustomer,
  updateCustomer,
  saveCustomer,
  updateOutstanding,
  removeOutstanding,
  getOutstanding,
  getwinloseReport,
  getEventResult,
  calculateEventResult,
  getSingleLiveData,
  saveBettingEventsConfirm,
  getVoucherDetails,
  getOverallVoucher,
  updateOverallVoucher,
  getPurchasedVouchers,
  createPurchasedVoucher,
  updatePurchasedVoucher,
  deletePurchasedVoucher,
  getEventListForSelect,
  calculatePurchasedVouchers,
  updateSetting,
  fetchSetting,
};
